import { Injectable } from '@angular/core';

// Import's Services:
import { ReportesRequestService } from './request/reportes-request.service';
import { FiltrosRequestService } from './request/filtros-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioComfenalcoService {

  constructor( private requestUrlReporte : ReportesRequestService,
               private requestUrlFiltro : FiltrosRequestService ) { }

  public async getBodyReport( objetoComfenalco : ComfenalcoServiceEntity ) {
    try {

      let response = await this.requestUrlReporte.getRequest(
        "comfenalco/comfenalco-detalle",
        [ objetoComfenalco.codigoBaseDatos,
            {
              "fechaInicial" : objetoComfenalco.fechaInicial,
              "fechaFinal" : objetoComfenalco.fechaFinal == null ? new Date() : objetoComfenalco.fechaFinal,
              "uncoEmpresa": objetoComfenalco.uncoEmpresa
            }
        ]
      );

      return response;

    }catch(exception) {
      console.log(exception);
    }
  }

  public async getResponseFiltersEmpresas( objetoComfenalco : ComfenalcoServiceEntity ) {

    try {

      let response = await this.requestUrlFiltro.getRequest(
        "comfenalco/empresas", [objetoComfenalco.codigoBaseDatos]
      );

      if(response != null) {
        return response;
      } else {
        return null;
      }

    } catch(exception) {
      console.log(exception);
    }
  }

}

export interface ComfenalcoServiceEntity {
  codigoBaseDatos : string,
  uncoEmpresa : number,
  fechaInicial : string,
  fechaFinal : string
}

export interface ObjetoComfenalcoEntity {

  afiliado: {
      nombreCompletoAfiliado: string,
      tipoIdentificacion: string,
      identificacion: string,
      fechaNacimiento: Date,
      telefono: string,
      celular: string,
      sexo: string
  },
  ambito: string,
  dxPrincipal: string,
  dxRelacionado: string,
  codigoActividad: string,
  codigoCups: number,
  descripcionCups: string,
  contrato: string,
  formaReconocimiento: string,
  numeroAutorizacion: string,
  tipoDocumentoPs: string,
  profesionalSalud: string,
  especialidad: string,
  valorActividad: number,
  valorCita: number,
  valorCtaMdrdra: number,
  valorCopago: number,
  peso: number,
  talla: number,
  cantidad: number,
  codigoDepartamento: number,
  codigoMunicipio: number,
  consecutivoFacturacion: number,
  duracionIncapacidad: number,
  generoIncapacidad: number,
  identificacionSede: number,
  identificacionTributaria: number,
  numeroDiasEstancia: number,
  numeroIncapacidad: number,
  fechaRadicacion: Date,
  horaRadicacion:string,
  fechaAutorizacion: Date,
  horaAutorizacion: string,
  fechaAtencion: Date,
  horaAtencion :string,
  fechaInicialIncapacidad: Date,
  fechaTerminaIncapacidad: Date,
  fechaPeso: Date,
  fechaTalla: Date,
  numeroIdentificacionProfesional : string

}